/* tslint:disable */
/* eslint-disable */
/**
 * SIBR
 * SIBR Backend API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DisruptionsCountOutput } from '../model';
// @ts-ignore
import { OutputErrorMessage } from '../model';
// @ts-ignore
import { TrafficInfoDetails } from '../model';
// @ts-ignore
import { TrafficInfoOutput } from '../model';
/**
 * TrafficInfoControllerApi - axios parameter creator
 * @export
 */
export const TrafficInfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current number of disruptions
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disruptionsCount: async (xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('disruptionsCount', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/traffic-info/disruptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Traffic Info
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trafficInfo: async (xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('trafficInfo', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/traffic-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Traffic Info details for the given network
         * @param {string} network 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trafficInfoDetails: async (network: string, xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('trafficInfoDetails', 'network', network)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('trafficInfoDetails', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/traffic-info/{network}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrafficInfoControllerApi - functional programming interface
 * @export
 */
export const TrafficInfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrafficInfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current number of disruptions
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disruptionsCount(xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisruptionsCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disruptionsCount(xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Traffic Info
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trafficInfo(xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficInfoOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trafficInfo(xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Traffic Info details for the given network
         * @param {string} network 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trafficInfoDetails(network: string, xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficInfoDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trafficInfoDetails(network, xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrafficInfoControllerApi - factory interface
 * @export
 */
export const TrafficInfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrafficInfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current number of disruptions
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disruptionsCount(xBffKey: string, options?: any): AxiosPromise<DisruptionsCountOutput> {
            return localVarFp.disruptionsCount(xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Traffic Info
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trafficInfo(xBffKey: string, options?: any): AxiosPromise<TrafficInfoOutput> {
            return localVarFp.trafficInfo(xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Traffic Info details for the given network
         * @param {string} network 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trafficInfoDetails(network: string, xBffKey: string, options?: any): AxiosPromise<TrafficInfoDetails> {
            return localVarFp.trafficInfoDetails(network, xBffKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrafficInfoControllerApi - object-oriented interface
 * @export
 * @class TrafficInfoControllerApi
 * @extends {BaseAPI}
 */
export class TrafficInfoControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get current number of disruptions
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficInfoControllerApi
     */
    public disruptionsCount(xBffKey: string, options?: AxiosRequestConfig) {
        return TrafficInfoControllerApiFp(this.configuration).disruptionsCount(xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Traffic Info
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficInfoControllerApi
     */
    public trafficInfo(xBffKey: string, options?: AxiosRequestConfig) {
        return TrafficInfoControllerApiFp(this.configuration).trafficInfo(xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Traffic Info details for the given network
     * @param {string} network 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficInfoControllerApi
     */
    public trafficInfoDetails(network: string, xBffKey: string, options?: AxiosRequestConfig) {
        return TrafficInfoControllerApiFp(this.configuration).trafficInfoDetails(network, xBffKey, options).then((request) => request(this.axios, this.basePath));
    }
}
